import axios, {
  AxiosHeaders,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from "axios";
import { handleCustomError, handleHttpError } from "../utils/errorHandler";
import { BASE_URL } from "./config";
import { showToast } from "../utils/toastUtils";

// ✅ Extend AxiosRequestConfig (Used in API calls)
export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  skipAuth?: boolean;
}

// ✅ Extend InternalAxiosRequestConfig (Used in Interceptors)
export interface CustomInternalAxiosRequestConfig
  extends InternalAxiosRequestConfig {
  skipAuth?: boolean;
}

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// ✅ Modify Request Interceptor to check `skipAuth`
axiosInstance.interceptors.request.use(
  (config) => {
    // ✅ Cast to CustomInternalAxiosRequestConfig
    const customConfig = config as CustomInternalAxiosRequestConfig;

    if (!customConfig.skipAuth) {
      const token = localStorage.getItem("Apptoken");
      if (token) {
        customConfig.headers["apptoken"] = token; // ✅ TypeScript-safe assignment
      }
    }
    if (process.env.NODE_ENV == "development") {
      // console.log("CustomConfig ===>", customConfig);
      // console.log("Complete Headers ===>", customConfig.headers);
      const fullUrl = `${customConfig.baseURL}${customConfig.url}`;
      // console.log("🚀 API Request URL:", fullUrl);
      // ✅ Log query params (if any)
      if (customConfig.params) {
        // console.log("🔹 Query Params:", customConfig.params);
      }
    }

    return customConfig;
  },
  (error) => Promise.reject(error)
);

// ✅ Modify Response Interceptor for Global Error Handling
axiosInstance.interceptors.response.use(
  (response) => {
    // console.log("inside response ",response)
    // ✅ Ensure `statusCode` exists and is 200, else reject as error
    if (
      response?.data?.statusCode &&
      response.data.statusCode !== 200 &&
      response.data.statusCode !== 201
    ) {
      console.warn(
        "🚨 API Error detected in interceptor:",
        response.data.message
      );
      handleCustomError(response);
      return Promise.reject({ response }); // ⛔️ Force it to be treated as an error
    }

    return response;
  },

  (error) => {
    console.error("API Error:", error.response?.data?.message || error.message);

    handleHttpError(error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
